import React from 'react';
import { 
  HelpCircle, 
  Heart, 
  Calendar, 
  ThermometerSun, 
  Utensils, 
  BedDouble, 
  Activity, 
  UserPlus
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами
 */
const TipsSidebar = ({ plannedPregnancy = true }) => {
  // Разные советы в зависимости от цели (планирование беременности или контрацепция)
  const tips = plannedPregnancy ? planningTips : contraceptionTips;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-rose-500" />
        {plannedPregnancy ? 'Советы по планированию' : 'Советы по контрацепции'}
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-rose-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Блок с консультацией специалиста */}
      <div className="mt-6 p-4 bg-rose-50 dark:bg-rose-900/20 border border-rose-100 dark:border-rose-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <UserPlus className="w-5 h-5 text-rose-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-rose-700 dark:text-rose-300 mb-2">
              Консультация специалиста
            </h4>
            <p className="text-xs text-rose-600 dark:text-rose-400 mb-3">
              {plannedPregnancy 
                ? 'Если вы планируете беременность более 6-12 месяцев без результата, рекомендуется проконсультироваться с врачом-репродуктологом.' 
                : 'Для подбора оптимального метода контрацепции рекомендуется проконсультироваться с гинекологом.'}
            </p>
            <button className="w-full py-1.5 text-xs bg-rose-500 text-white rounded hover:bg-rose-600 transition-colors">
              Найти специалиста
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Советы для планирования беременности
const planningTips = [
  {
    icon: Heart,
    title: 'Отслеживайте свой цикл',
    description: 'Ведите учет менструаций в течение нескольких месяцев для более точного прогнозирования овуляции'
  },
  {
    icon: ThermometerSun,
    title: 'Измеряйте базальную температуру',
    description: 'Измеряйте температуру тела каждое утро сразу после пробуждения, не вставая с постели'
  },
  {
    icon: Calendar,
    title: 'Используйте тесты на овуляцию',
    description: 'Начинайте тестирование за несколько дней до предполагаемой овуляции'
  },
  {
    icon: BedDouble,
    title: 'Оптимальная частота близости',
    description: 'Во время фертильного окна рекомендуется близость каждые 1-2 дня'
  },
  {
    icon: Utensils,
    title: 'Правильное питание',
    description: 'Включите в рацион продукты, богатые фолиевой кислотой, железом, кальцием и омега-3'
  },
  {
    icon: Activity,
    title: 'Умеренная физическая активность',
    description: 'Поддерживайте регулярную, но не чрезмерную физическую активность'
  }
];

// Советы для контрацепции
const contraceptionTips = [
  {
    icon: Calendar,
    title: 'Не полагайтесь только на календарный метод',
    description: 'Календарный метод имеет низкую эффективность и не защищает от ИППП'
  },
  {
    icon: Heart,
    title: 'Используйте барьерные методы',
    description: 'В фертильные дни обязательно используйте презервативы или другие барьерные методы'
  },
  {
    icon: ThermometerSun,
    title: 'Комбинируйте методы',
    description: 'Для повышения надежности комбинируйте календарный метод с другими методами контрацепции'
  },
  {
    icon: Activity,
    title: 'Учитывайте факторы, влияющие на цикл',
    description: 'Стресс, болезни, смена климата могут сдвинуть день овуляции'
  },
  {
    icon: BedDouble,
    title: 'Помните о сперматозоидах',
    description: 'Сперматозоиды могут сохранять жизнеспособность до 5-7 дней в женском организме'
  },
  {
    icon: UserPlus,
    title: 'Проконсультируйтесь с врачом',
    description: 'Врач-гинеколог поможет подобрать наиболее подходящий метод контрацепции для вас'
  }
];

export default TipsSidebar;